// dexieUtils.js
import Dexie from 'dexie';

const db = new Dexie('ql');
db.version(1).stores({
    datasets: 'id, data'
});

export const saveDataset = async (key, data) => {
    try {
        await db.datasets.put({ id: key, data: data });
    } catch (error) {
        console.error('Error saving dataset:', error);
        throw error;
    }
};

export const getDataset = async (key) => {
    try {
        const result = await db.datasets.get(key);
        return result ? result.data : null;
    } catch (error) {
        console.error('Error getting dataset:', error);
        throw error;
    }
};

export const listAllKeys = async () => {
    try {
        const allKeys = await db.datasets.toCollection().keys();
        return allKeys;
    } catch (error) {
        console.error('Error listing keys:', error);
        throw error;
    }
};

export const deleteDataset = async (key, data) => {
    try {
        await db.datasets.put({ id: key, data: data });
    } catch (error) {
        console.error('Error deleting dataset:', error);
        throw error;
    }
};

export const clearDb = async () => {
    try {
        await db.datasets.clear();
    } catch (error) {
        console.error('Error clearing database:', error);
        throw error;
    }
};


export const isDatabaseEmpty = async () => {
    try {
        const count = await db.datasets.count();
        return count === 0;
    } catch (error) {
        console.error('Error checking database:', error);
        throw error;
    }
};